import { render, staticRenderFns } from "./job-setup-main.component.vue?vue&type=template&id=08d27bf6&scoped=true"
import script from "./job-setup-main.component.ts?vue&type=script&lang=ts&external"
export * from "./job-setup-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job-setup-main.component.vue?vue&type=style&index=0&id=08d27bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d27bf6",
  null
  
)

export default component.exports